/* eslint-disable camelcase */
import React from "react";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";
import { originStatusName, sapStatusName } from "./utils";

const ConciliationStatus = ({ sapStatus, concStatus }) => {
  const conciliationText = originStatusName(concStatus);
  const sapText = sapStatusName(sapStatus);
  let sapClassName = "cp-badge badge-sap sap-pending";
  if (sapStatus === 2) {
    sapClassName += " send";
  } else if (sapStatus === 7) {
    sapClassName += " deleted";
  }
  return (
    <div className="conciliation-status ">
      {concStatus !== -1 && (
        <Badge pill className="cp-badge badge-conciliated">
          {conciliationText}{" "}
        </Badge>
      )}
      {sapStatus !== -1 && (
        <Badge pill className={sapClassName}>
          {sapText}
        </Badge>
      )}
    </div>
  );
};

ConciliationStatus.propTypes = {
  sapStatus: PropTypes.number,
  concStatus: PropTypes.number
};

ConciliationStatus.defaultProps = {
  sapStatus: -1,
  concStatus: -1
};

export default ConciliationStatus;
